module.exports = __webpack_public_path__ + "media/images/logo-full-2b581ee25f722432fa474299d39d7b33.svg";